import { isValidElement, ReactChild } from 'react'

export default function RenderThumbs(children: ReactChild[]) {
  return children.map((child) => {
    if (!isValidElement(child)) return child

    return (
      <div style={{ position: 'relative', height: 70 }} key={child.key}>
        {child}
      </div>
    )
  })
}
